import React from 'react'

const Error = () => {
  return (
    <h1 className="text-3xl  text-center text-white lg:mt-52 mt-80">
      Error 404 - Page Not Found⚠️
    </h1>
  )
}

export default Error